import React from 'react';
import { FaTrashAlt, FaEdit, FaIndustry, FaCity, FaWarehouse, FaHome, FaBuilding, FaMapMarkerAlt } from 'react-icons/fa';

const DivisionCard = ({ name, onClick, onDelete, onEdit, stats }) => {
  // Get appropriate icon based on division name
  const getDivisionIcon = () => {
    const division = name.toLowerCase();
    if (division.includes('vita')) return <FaIndustry className="text-blue-600" />;
    if (division.includes('satara')) return <FaIndustry className="text-green-600" />;
    if (division.includes('pune')) return <FaIndustry className="text-purple-600" />;
    if (division.includes('kolhapur')) return <FaIndustry className="text-orange-600" />;
    if (division.includes('mumbai')) return <FaIndustry className="text-red-600" />;
    if (division.includes('jath')) return <FaIndustry className="text-teal-600" />;
    return <FaMapMarkerAlt className="text-indigo-600" />;
  };

  const isDefault = false;

  const totalCompleted = stats ? Object.values(stats).reduce((acc, curr) => acc + curr.completed, 0) : 0;
  const totalPending = stats ? Object.values(stats).reduce((acc, curr) => acc + curr.pending, 0) : 0;
  const totalTransformers = totalCompleted + totalPending;

  return (
    <div className="relative group h-full">
      <div
        onClick={onClick}
        className={`flex flex-col h-full border rounded-xl overflow-hidden shadow-sm transition-all duration-300 cursor-pointer
                  ${isDefault 
                    ? 'bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-100 hover:border-blue-200' 
                    : 'bg-white border-gray-200 hover:border-indigo-200 hover:shadow-md'
                  }
                  hover:-translate-y-1`}
      >
        <div className="p-5 flex flex-col h-full">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-indigo-50 border border-indigo-100 shadow-sm shrink-0">
              {getDivisionIcon()}
            </div>
            <h3 className={`font-bold text-lg tracking-tight leading-tight line-clamp-2 ${
              isDefault ? 'text-blue-800' : 'text-gray-900'
            }`}>
              {name}
            </h3>
          </div>
          
          <div className="mt-auto grid grid-cols-3 bg-gray-50/80 rounded-xl p-3 border border-gray-100 shadow-inner">
            <div className="flex flex-col items-center justify-center">
              <span className="text-gray-400 font-bold uppercase tracking-widest text-[9px] mb-1">Total</span>
              <span className="font-black text-gray-800 text-sm">{totalTransformers}</span>
            </div>
            <div className="flex flex-col items-center justify-center border-l border-r border-gray-200/60">
              <span className="text-gray-400 font-bold uppercase tracking-widest text-[9px] mb-1">Complete</span>
              <span className="font-black text-emerald-600 text-sm">{totalCompleted}</span>
            </div>
            <div className="flex flex-col items-center justify-center">
              <span className="text-gray-400 font-bold uppercase tracking-widest text-[9px] mb-1">Pending</span>
              <span className="font-black text-rose-600 text-sm">{totalPending}</span>
            </div>
          </div>
        </div>
      </div>

      {!isDefault && (
        <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          {onEdit && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
              className="p-1.5 bg-white rounded-md shadow-xs border border-gray-200 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 transition-colors"
              title="Edit"
            >
              <FaEdit size={12} />
            </button>
          )}
          {onDelete && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
              className="p-1.5 bg-white rounded-md shadow-xs border border-gray-200 text-gray-600 hover:text-red-600 hover:bg-red-50 transition-colors"
              title="Delete"
            >
              <FaTrashAlt size={12} />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default DivisionCard;